'use strict';

module.exports = require('./src/DialogWrap');



// WEBPACK FOOTER //
// ./index.js